/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';

export default class CampaignsEmptyStateComponent extends Component {
  @service analytics!: AnalyticsService;
  @service router!: RouterService;

  readonly emptyStateImage = new URL('cio/assets/images/campaigns-empty-state.png', import.meta.url).toString();
  constructor(owner: unknown, args: never) {
    super(owner, args);
    this.analytics.track('campaign', 'empty_state_viewed');
  }

  @action
  handleLearnMoreClick() {
    this.analytics.track('campaign', 'empty_state_learn_more_clicked');
  }

  @action
  handleCreateCampaignClick() {
    this.analytics.track('campaign', 'empty_state_create_campaign_clicked');
  }
}
